import { message as $message } from 'antd'
import { queryGoodsQtyConfig, queryItemCodeLikeSearch, queryPartnerSpuItemCodeLikeSearch } from '@/services/myGoods'

const goodsModel = {
    namespace: 'goods',
    state: {
        qtyInfo: {},
        itemCodeVague: undefined,
        distributionItemCodeVague: undefined
    },
    effects: {
        *queryGoodsQtyConfig({ payload }, { call, put }) {
            const response = yield call(queryGoodsQtyConfig)

            if (response) {
                const { success, message, data } = response
                if (success) {
                    yield put({
                        type: 'update',
                        payload: {
                            qtyInfo: data
                        }
                    })
                } else {
                    $message.error(message)
                }
            }
        },
        *queryItemCodeLikeSearch(_, { call, put, select }) {
            try {
                const itemCodeVague = yield select(state => state.goods.itemCodeVague)

                if (itemCodeVague) {
                    return itemCodeVague
                }

                const response = yield call(queryItemCodeLikeSearch)

                if (response) {
                    const { success, message, data } = response

                    const itemCodeVague = !data ? '1' : '0'

                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                itemCodeVague
                            }
                        })

                        return itemCodeVague
                    } else {
                        $message.error(message)
                    }

                    return '0'
                }
            } catch (e) {
                console.error(e)

                return '0'
            }
        },
        *queryDistributionItemCodeLikeSearch(_, { call, put, select }) {
            try {
                const distributionItemCodeVague = yield select(state => state.goods.distributionItemCodeVague)

                if (distributionItemCodeVague) {
                    return distributionItemCodeVague
                }

                const response = yield call(queryPartnerSpuItemCodeLikeSearch)

                if (response) {
                    const { success, message, data } = response

                    const distributionItemCodeVague = !data ? '1' : '0'

                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                distributionItemCodeVague
                            }
                        })

                        return distributionItemCodeVague
                    } else {
                        $message.error(message)
                    }

                    return '0'
                }
            } catch (e) {
                console.error(e)

                return '0'
            }
        }
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload
            }
        }
    }
}

export default goodsModel
